// Textos da Agenda da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.agenda.titulo': 'Agenda',
    'farm.agenda.ajuda': 'Cada linha é um vencimento. Concluir uma obrigação recorrente cria a próxima sozinha, contada do vencimento. O aviso aparece no Início a partir dos dias de antecedência de cada obrigação.',
    'farm.agenda.busca': 'Buscar obrigação, imóvel ou responsável',
    'farm.agenda.kpi.atrasadas': 'Atrasadas',
    'farm.agenda.kpi.vence_7': 'Vencem em 7 dias',
    'farm.agenda.kpi.vence_30': 'Vencem em 30 dias',
    'farm.agenda.kpi.concluidas_mes': 'Concluídas no mês',
    'farm.agenda.categoria.itr': 'ITR',
    'farm.agenda.categoria.car': 'CAR',
    'farm.agenda.categoria.licenca_ambiental': 'Licença ambiental',
    'farm.agenda.categoria.outorga': 'Outorga',
    'farm.agenda.categoria.fiscalizacao': 'Fiscalização',
    'farm.agenda.categoria.taxa': 'Taxa',
    'farm.agenda.categoria.contrato': 'Contrato',
    'farm.agenda.categoria.certidao': 'Certidão',
    'farm.agenda.categoria.pessoal': 'Pessoal',
    'farm.agenda.recorrencia.unica': 'Única',
    'farm.agenda.recorrencia.mensal': 'Mensal',
    'farm.agenda.recorrencia.anual': 'Anual',
    'farm.agenda.recorrencia.meses': 'A cada N meses',
    'farm.agenda.recorrencia.aCada': 'A cada {{n}} meses',
    'farm.agenda.status.aberta': 'Em aberto',
    'farm.agenda.status.atrasada': 'Atrasada',
    'farm.agenda.status.pendente': 'Pendente',
    'farm.agenda.status.concluida': 'Concluída',
    'farm.agenda.periodo.mes': 'Este mês',
    'farm.agenda.periodo.proximo_mes': 'Próximo mês',
    'farm.agenda.periodo.dias_90': 'Próximos 90 dias',
    'farm.agenda.periodo.ano': 'Este ano',
    'farm.agenda.filtro.dono': 'Imóvel',
    'farm.agenda.filtro.categoria': 'Categoria',
    'farm.agenda.filtro.status': 'Status',
    'farm.agenda.filtro.periodo': 'Período',
    'farm.agenda.todos': 'Todos',
    'farm.agenda.todas': 'Todas',
    'farm.agenda.col.obrigacao': 'Obrigação',
    'farm.agenda.col.dono': 'Imóvel',
    'farm.agenda.col.vencimento': 'Vencimento',
    'farm.agenda.col.responsavel': 'Responsável',
    'farm.agenda.col.documento': 'Documento',
    'farm.agenda.col.acoes': 'Ações',
    'farm.agenda.prazo.atrasada': 'Atrasada há {{dias}} dias',
    'farm.agenda.prazo.atrasadaUm': 'Atrasada há 1 dia',
    'farm.agenda.prazo.hoje': 'Vence hoje',
    'farm.agenda.prazo.amanha': 'Vence amanhã',
    'farm.agenda.prazo.emDias': 'Vence em {{dias}} dias',
    'farm.agenda.prazo.emDia': 'Em dia',
    'farm.agenda.prazo.concluida': 'Concluída',
    'farm.agenda.concluidaEm': 'Concluída em {{data}}',
    'farm.agenda.aviso': 'Aviso {{dias}} dias antes',
    'farm.agenda.avisoNoDia': 'Aviso no dia',
    'farm.agenda.adiadaUma': 'Adiada uma vez',
    'farm.agenda.adiadaVezes': 'Adiada {{n}} vezes',
    'farm.agenda.semDocumento': 'Sem documento',
    'farm.agenda.abrirDocumento': 'Abrir o documento',
    'farm.agenda.dono.geral': 'Geral',
    'farm.agenda.dono.geralNome': 'Todos os imóveis',
    'farm.agenda.dono.pessoal': 'Pessoal',
    'farm.agenda.dono.pessoalNome': 'Obrigações pessoais',
    'farm.agenda.dono.fundo': 'Fundo',
    'farm.agenda.acao.concluir': 'Concluir',
    'farm.agenda.acao.adiar': 'Adiar',
    'farm.agenda.acao.editar': 'Editar',
    'farm.agenda.acao.historico': 'Histórico',
    'farm.agenda.nova': 'Nova obrigação',
    'farm.agenda.excel': 'Excel',
    'farm.agenda.vista': 'Vista',
    'farm.agenda.vista.lista': 'Lista',
    'farm.agenda.vista.calendario': 'Calendário',
    'farm.agenda.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.agenda.salva': 'Obrigação salva',
    'farm.agenda.concluidaToast': 'Obrigação concluída',
    'farm.agenda.proximaToast': 'Concluída. A próxima vence em {{data}}',
    'farm.agenda.adiadaToast': 'Vencimento adiado para {{data}}',
    'farm.agenda.form.nova': 'Nova obrigação',
    'farm.agenda.form.editar': 'Editar obrigação',
    'farm.agenda.form.titulo': 'Título',
    'farm.agenda.form.categoria': 'Categoria',
    'farm.agenda.form.dono': 'Imóvel ou fundo',
    'farm.agenda.form.vencimento': 'Vencimento',
    'farm.agenda.form.recorrencia': 'Recorrência',
    'farm.agenda.form.meses': 'A cada quantos meses',
    'farm.agenda.form.antecedencia': 'Avisar quantos dias antes',
    'farm.agenda.form.responsavel': 'Responsável',
    'farm.agenda.form.documento': 'Documento',
    'farm.agenda.form.nenhum': 'Nenhum',
    'farm.agenda.form.observacao': 'Observação',
    'farm.agenda.erro.titulo': 'Informe o título',
    'farm.agenda.erro.categoria': 'Escolha a categoria',
    'farm.agenda.erro.dono': 'Escolha o imóvel ou o fundo',
    'farm.agenda.erro.vencimento': 'Informe o vencimento',
    'farm.agenda.erro.meses': 'De 2 a 60 meses',
    'farm.agenda.erro.antecedencia': 'De 0 a 365 dias',
    'farm.agenda.erro.responsavel': 'Informe o responsável',
    'farm.agenda.erro.motivo': 'Informe o motivo',
    'farm.agenda.erro.depois': 'Escolha um dia depois de {{data}}',
    'farm.agenda.concluir.titulo': 'Concluir obrigação',
    'farm.agenda.concluir.dia': 'Concluída em',
    'farm.agenda.concluir.nota': 'Nota',
    'farm.agenda.concluir.proxima': 'A próxima ocorrência nasce com vencimento em {{data}}.',
    'farm.agenda.concluir.unica': 'Obrigação única: não gera próxima ocorrência.',
    'farm.agenda.adiar.titulo': 'Adiar vencimento',
    'farm.agenda.adiar.novo': 'Novo vencimento',
    'farm.agenda.adiar.motivo': 'Motivo',
    'farm.agenda.adiar.atual': 'O vencimento atual é {{data}}.',
    'farm.agenda.historico.titulo': 'Histórico',
    'farm.agenda.historico.vencimentos': 'Vencimentos',
    'farm.agenda.historico.eventos': 'Movimentos',
    'farm.agenda.historico.evento.criada': 'Criada',
    'farm.agenda.historico.evento.concluida': 'Concluída',
    'farm.agenda.historico.evento.adiada': 'Adiada',
    'farm.agenda.historico.evento.editada': 'Editada',
    'farm.agenda.historico.evento.gerada': 'Próxima ocorrência',
    'farm.agenda.historico.de': 'De {{de}} para {{para}}',
    'farm.agenda.historico.vence': 'Vencimento {{data}}',
    'farm.agenda.historico.por': 'por {{nome}}',
    'farm.agenda.fechar': 'Fechar',
    'farm.agenda.calendario.hoje': 'Hoje',
    'farm.agenda.calendario.anterior': 'Mês anterior',
    'farm.agenda.calendario.seguinte': 'Mês seguinte',
    'farm.agenda.calendario.mais': 'mais {{n}}',
    'farm.agenda.calendario.vazio': 'Nada vence neste dia.',
    'farm.agenda.calendario.doDia': 'Vencimentos do dia {{data}}',
    'farm.agenda.calendario.noMes': '{{n}} vencimentos no mês',
    'farm.agenda.calendario.umNoMes': '1 vencimento no mês',
    'farm.agenda.compacta.abrir': 'Abrir na Agenda',
    'farm.agenda.compacta.vazio': 'Nenhuma obrigação em aberto.',
    'farm.agenda.compacta.emAberto': '{{n}} em aberto',
  },
  en: {
    'farm.agenda.titulo': 'Calendar',
    'farm.agenda.ajuda': 'Each row is a due date. Completing a recurring obligation creates the next one, counted from the due date. The alert shows on Home from each obligation\'s notice days.',
    'farm.agenda.busca': 'Search obligation, property or owner',
    'farm.agenda.kpi.atrasadas': 'Overdue',
    'farm.agenda.kpi.vence_7': 'Due in 7 days',
    'farm.agenda.kpi.vence_30': 'Due in 30 days',
    'farm.agenda.kpi.concluidas_mes': 'Done this month',
    'farm.agenda.categoria.itr': 'Rural land tax',
    'farm.agenda.categoria.car': 'Rural registry',
    'farm.agenda.categoria.licenca_ambiental': 'Environmental license',
    'farm.agenda.categoria.outorga': 'Water permit',
    'farm.agenda.categoria.fiscalizacao': 'Inspection',
    'farm.agenda.categoria.taxa': 'Fee',
    'farm.agenda.categoria.contrato': 'Contract',
    'farm.agenda.categoria.certidao': 'Certificate',
    'farm.agenda.categoria.pessoal': 'Personal',
    'farm.agenda.recorrencia.unica': 'One time',
    'farm.agenda.recorrencia.mensal': 'Monthly',
    'farm.agenda.recorrencia.anual': 'Yearly',
    'farm.agenda.recorrencia.meses': 'Every N months',
    'farm.agenda.recorrencia.aCada': 'Every {{n}} months',
    'farm.agenda.status.aberta': 'Open',
    'farm.agenda.status.atrasada': 'Overdue',
    'farm.agenda.status.pendente': 'Pending',
    'farm.agenda.status.concluida': 'Done',
    'farm.agenda.periodo.mes': 'This month',
    'farm.agenda.periodo.proximo_mes': 'Next month',
    'farm.agenda.periodo.dias_90': 'Next 90 days',
    'farm.agenda.periodo.ano': 'This year',
    'farm.agenda.filtro.dono': 'Property',
    'farm.agenda.filtro.categoria': 'Category',
    'farm.agenda.filtro.status': 'Status',
    'farm.agenda.filtro.periodo': 'Period',
    'farm.agenda.todos': 'All',
    'farm.agenda.todas': 'All',
    'farm.agenda.col.obrigacao': 'Obligation',
    'farm.agenda.col.dono': 'Property',
    'farm.agenda.col.vencimento': 'Due date',
    'farm.agenda.col.responsavel': 'Owner',
    'farm.agenda.col.documento': 'Document',
    'farm.agenda.col.acoes': 'Actions',
    'farm.agenda.prazo.atrasada': 'Overdue by {{dias}} days',
    'farm.agenda.prazo.atrasadaUm': 'Overdue by 1 day',
    'farm.agenda.prazo.hoje': 'Due today',
    'farm.agenda.prazo.amanha': 'Due tomorrow',
    'farm.agenda.prazo.emDias': 'Due in {{dias}} days',
    'farm.agenda.prazo.emDia': 'On track',
    'farm.agenda.prazo.concluida': 'Done',
    'farm.agenda.concluidaEm': 'Done on {{data}}',
    'farm.agenda.aviso': 'Alert {{dias}} days before',
    'farm.agenda.avisoNoDia': 'Alert on the day',
    'farm.agenda.adiadaUma': 'Postponed once',
    'farm.agenda.adiadaVezes': 'Postponed {{n}} times',
    'farm.agenda.semDocumento': 'No document',
    'farm.agenda.abrirDocumento': 'Open the document',
    'farm.agenda.dono.geral': 'General',
    'farm.agenda.dono.geralNome': 'All properties',
    'farm.agenda.dono.pessoal': 'Personal',
    'farm.agenda.dono.pessoalNome': 'Personal obligations',
    'farm.agenda.dono.fundo': 'Fund',
    'farm.agenda.acao.concluir': 'Complete',
    'farm.agenda.acao.adiar': 'Postpone',
    'farm.agenda.acao.editar': 'Edit',
    'farm.agenda.acao.historico': 'History',
    'farm.agenda.nova': 'New obligation',
    'farm.agenda.excel': 'Excel',
    'farm.agenda.vista': 'View',
    'farm.agenda.vista.lista': 'List',
    'farm.agenda.vista.calendario': 'Calendar',
    'farm.agenda.semResultado': 'Nothing to show with these filters.',
    'farm.agenda.salva': 'Obligation saved',
    'farm.agenda.concluidaToast': 'Obligation completed',
    'farm.agenda.proximaToast': 'Completed. The next one is due on {{data}}',
    'farm.agenda.adiadaToast': 'Due date moved to {{data}}',
    'farm.agenda.form.nova': 'New obligation',
    'farm.agenda.form.editar': 'Edit obligation',
    'farm.agenda.form.titulo': 'Title',
    'farm.agenda.form.categoria': 'Category',
    'farm.agenda.form.dono': 'Property or fund',
    'farm.agenda.form.vencimento': 'Due date',
    'farm.agenda.form.recorrencia': 'Recurrence',
    'farm.agenda.form.meses': 'Every how many months',
    'farm.agenda.form.antecedencia': 'Alert how many days before',
    'farm.agenda.form.responsavel': 'Owner',
    'farm.agenda.form.documento': 'Document',
    'farm.agenda.form.nenhum': 'None',
    'farm.agenda.form.observacao': 'Note',
    'farm.agenda.erro.titulo': 'Enter the title',
    'farm.agenda.erro.categoria': 'Choose the category',
    'farm.agenda.erro.dono': 'Choose the property or the fund',
    'farm.agenda.erro.vencimento': 'Enter the due date',
    'farm.agenda.erro.meses': 'From 2 to 60 months',
    'farm.agenda.erro.antecedencia': 'From 0 to 365 days',
    'farm.agenda.erro.responsavel': 'Enter the owner',
    'farm.agenda.erro.motivo': 'Enter the reason',
    'farm.agenda.erro.depois': 'Pick a day after {{data}}',
    'farm.agenda.concluir.titulo': 'Complete obligation',
    'farm.agenda.concluir.dia': 'Completed on',
    'farm.agenda.concluir.nota': 'Note',
    'farm.agenda.concluir.proxima': 'The next occurrence is created due on {{data}}.',
    'farm.agenda.concluir.unica': 'One time obligation: no next occurrence.',
    'farm.agenda.adiar.titulo': 'Postpone due date',
    'farm.agenda.adiar.novo': 'New due date',
    'farm.agenda.adiar.motivo': 'Reason',
    'farm.agenda.adiar.atual': 'Currently due on {{data}}.',
    'farm.agenda.historico.titulo': 'History',
    'farm.agenda.historico.vencimentos': 'Due dates',
    'farm.agenda.historico.eventos': 'Activity',
    'farm.agenda.historico.evento.criada': 'Created',
    'farm.agenda.historico.evento.concluida': 'Completed',
    'farm.agenda.historico.evento.adiada': 'Postponed',
    'farm.agenda.historico.evento.editada': 'Edited',
    'farm.agenda.historico.evento.gerada': 'Next occurrence',
    'farm.agenda.historico.de': 'From {{de}} to {{para}}',
    'farm.agenda.historico.vence': 'Due {{data}}',
    'farm.agenda.historico.por': 'by {{nome}}',
    'farm.agenda.fechar': 'Close',
    'farm.agenda.calendario.hoje': 'Today',
    'farm.agenda.calendario.anterior': 'Previous month',
    'farm.agenda.calendario.seguinte': 'Next month',
    'farm.agenda.calendario.mais': '{{n}} more',
    'farm.agenda.calendario.vazio': 'Nothing due on this day.',
    'farm.agenda.calendario.doDia': 'Due on {{data}}',
    'farm.agenda.calendario.noMes': '{{n}} due this month',
    'farm.agenda.calendario.umNoMes': '1 due this month',
    'farm.agenda.compacta.abrir': 'Open in Calendar',
    'farm.agenda.compacta.vazio': 'No open obligations.',
    'farm.agenda.compacta.emAberto': '{{n}} open',
  },
  es: {
    'farm.agenda.titulo': 'Agenda',
    'farm.agenda.ajuda': 'Cada fila es un vencimiento. Concluir una obligación recurrente crea la siguiente sola, contada desde el vencimiento. El aviso aparece en Inicio desde los días de antelación de cada obligación.',
    'farm.agenda.busca': 'Buscar obligación, inmueble o responsable',
    'farm.agenda.kpi.atrasadas': 'Atrasadas',
    'farm.agenda.kpi.vence_7': 'Vencen en 7 días',
    'farm.agenda.kpi.vence_30': 'Vencen en 30 días',
    'farm.agenda.kpi.concluidas_mes': 'Concluidas en el mes',
    'farm.agenda.categoria.itr': 'Impuesto rural',
    'farm.agenda.categoria.car': 'Registro rural',
    'farm.agenda.categoria.licenca_ambiental': 'Licencia ambiental',
    'farm.agenda.categoria.outorga': 'Concesión de agua',
    'farm.agenda.categoria.fiscalizacao': 'Fiscalización',
    'farm.agenda.categoria.taxa': 'Tasa',
    'farm.agenda.categoria.contrato': 'Contrato',
    'farm.agenda.categoria.certidao': 'Certificado',
    'farm.agenda.categoria.pessoal': 'Personal',
    'farm.agenda.recorrencia.unica': 'Única',
    'farm.agenda.recorrencia.mensal': 'Mensual',
    'farm.agenda.recorrencia.anual': 'Anual',
    'farm.agenda.recorrencia.meses': 'Cada N meses',
    'farm.agenda.recorrencia.aCada': 'Cada {{n}} meses',
    'farm.agenda.status.aberta': 'Abiertas',
    'farm.agenda.status.atrasada': 'Atrasada',
    'farm.agenda.status.pendente': 'Pendiente',
    'farm.agenda.status.concluida': 'Concluida',
    'farm.agenda.periodo.mes': 'Este mes',
    'farm.agenda.periodo.proximo_mes': 'Próximo mes',
    'farm.agenda.periodo.dias_90': 'Próximos 90 días',
    'farm.agenda.periodo.ano': 'Este año',
    'farm.agenda.filtro.dono': 'Inmueble',
    'farm.agenda.filtro.categoria': 'Categoría',
    'farm.agenda.filtro.status': 'Estado',
    'farm.agenda.filtro.periodo': 'Período',
    'farm.agenda.todos': 'Todos',
    'farm.agenda.todas': 'Todas',
    'farm.agenda.col.obrigacao': 'Obligación',
    'farm.agenda.col.dono': 'Inmueble',
    'farm.agenda.col.vencimento': 'Vencimiento',
    'farm.agenda.col.responsavel': 'Responsable',
    'farm.agenda.col.documento': 'Documento',
    'farm.agenda.col.acoes': 'Acciones',
    'farm.agenda.prazo.atrasada': 'Atrasada hace {{dias}} días',
    'farm.agenda.prazo.atrasadaUm': 'Atrasada hace 1 día',
    'farm.agenda.prazo.hoje': 'Vence hoy',
    'farm.agenda.prazo.amanha': 'Vence mañana',
    'farm.agenda.prazo.emDias': 'Vence en {{dias}} días',
    'farm.agenda.prazo.emDia': 'Al día',
    'farm.agenda.prazo.concluida': 'Concluida',
    'farm.agenda.concluidaEm': 'Concluida el {{data}}',
    'farm.agenda.aviso': 'Aviso {{dias}} días antes',
    'farm.agenda.avisoNoDia': 'Aviso el mismo día',
    'farm.agenda.adiadaUma': 'Aplazada una vez',
    'farm.agenda.adiadaVezes': 'Aplazada {{n}} veces',
    'farm.agenda.semDocumento': 'Sin documento',
    'farm.agenda.abrirDocumento': 'Abrir el documento',
    'farm.agenda.dono.geral': 'General',
    'farm.agenda.dono.geralNome': 'Todos los inmuebles',
    'farm.agenda.dono.pessoal': 'Personal',
    'farm.agenda.dono.pessoalNome': 'Obligaciones personales',
    'farm.agenda.dono.fundo': 'Fondo',
    'farm.agenda.acao.concluir': 'Concluir',
    'farm.agenda.acao.adiar': 'Aplazar',
    'farm.agenda.acao.editar': 'Editar',
    'farm.agenda.acao.historico': 'Historial',
    'farm.agenda.nova': 'Nueva obligación',
    'farm.agenda.excel': 'Excel',
    'farm.agenda.vista': 'Vista',
    'farm.agenda.vista.lista': 'Lista',
    'farm.agenda.vista.calendario': 'Calendario',
    'farm.agenda.semResultado': 'Nada que mostrar con estos filtros.',
    'farm.agenda.salva': 'Obligación guardada',
    'farm.agenda.concluidaToast': 'Obligación concluida',
    'farm.agenda.proximaToast': 'Concluida. La siguiente vence el {{data}}',
    'farm.agenda.adiadaToast': 'Vencimiento aplazado al {{data}}',
    'farm.agenda.form.nova': 'Nueva obligación',
    'farm.agenda.form.editar': 'Editar obligación',
    'farm.agenda.form.titulo': 'Título',
    'farm.agenda.form.categoria': 'Categoría',
    'farm.agenda.form.dono': 'Inmueble o fondo',
    'farm.agenda.form.vencimento': 'Vencimiento',
    'farm.agenda.form.recorrencia': 'Recurrencia',
    'farm.agenda.form.meses': 'Cada cuántos meses',
    'farm.agenda.form.antecedencia': 'Avisar cuántos días antes',
    'farm.agenda.form.responsavel': 'Responsable',
    'farm.agenda.form.documento': 'Documento',
    'farm.agenda.form.nenhum': 'Ninguno',
    'farm.agenda.form.observacao': 'Observación',
    'farm.agenda.erro.titulo': 'Informe el título',
    'farm.agenda.erro.categoria': 'Elija la categoría',
    'farm.agenda.erro.dono': 'Elija el inmueble o el fondo',
    'farm.agenda.erro.vencimento': 'Informe el vencimiento',
    'farm.agenda.erro.meses': 'De 2 a 60 meses',
    'farm.agenda.erro.antecedencia': 'De 0 a 365 días',
    'farm.agenda.erro.responsavel': 'Informe el responsable',
    'farm.agenda.erro.motivo': 'Informe el motivo',
    'farm.agenda.erro.depois': 'Elija un día después del {{data}}',
    'farm.agenda.concluir.titulo': 'Concluir obligación',
    'farm.agenda.concluir.dia': 'Concluida el',
    'farm.agenda.concluir.nota': 'Nota',
    'farm.agenda.concluir.proxima': 'La siguiente ocurrencia nace con vencimiento el {{data}}.',
    'farm.agenda.concluir.unica': 'Obligación única: no genera siguiente ocurrencia.',
    'farm.agenda.adiar.titulo': 'Aplazar vencimiento',
    'farm.agenda.adiar.novo': 'Nuevo vencimiento',
    'farm.agenda.adiar.motivo': 'Motivo',
    'farm.agenda.adiar.atual': 'El vencimiento actual es el {{data}}.',
    'farm.agenda.historico.titulo': 'Historial',
    'farm.agenda.historico.vencimentos': 'Vencimientos',
    'farm.agenda.historico.eventos': 'Movimientos',
    'farm.agenda.historico.evento.criada': 'Creada',
    'farm.agenda.historico.evento.concluida': 'Concluida',
    'farm.agenda.historico.evento.adiada': 'Aplazada',
    'farm.agenda.historico.evento.editada': 'Editada',
    'farm.agenda.historico.evento.gerada': 'Siguiente ocurrencia',
    'farm.agenda.historico.de': 'Del {{de}} al {{para}}',
    'farm.agenda.historico.vence': 'Vencimiento {{data}}',
    'farm.agenda.historico.por': 'por {{nome}}',
    'farm.agenda.fechar': 'Cerrar',
    'farm.agenda.calendario.hoje': 'Hoy',
    'farm.agenda.calendario.anterior': 'Mes anterior',
    'farm.agenda.calendario.seguinte': 'Mes siguiente',
    'farm.agenda.calendario.mais': '{{n}} más',
    'farm.agenda.calendario.vazio': 'Nada vence este día.',
    'farm.agenda.calendario.doDia': 'Vencimientos del {{data}}',
    'farm.agenda.calendario.noMes': '{{n}} vencimientos en el mes',
    'farm.agenda.calendario.umNoMes': '1 vencimiento en el mes',
    'farm.agenda.compacta.abrir': 'Abrir en la Agenda',
    'farm.agenda.compacta.vazio': 'Ninguna obligación abierta.',
    'farm.agenda.compacta.emAberto': '{{n}} abiertas',
  },
}
